module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABIBAMAAACnw650AAAAFVBMVEUAAADm5+jm5+jm5+jm5+jm5+jm5+g8dULQAAAAB3RSTlMAIJ/v/wAwF8MKgAAAAFpJREFUeAFjGP5AyMQFB3BWDAUCBiAOQ6jBVJUKVSTsggcYQhWp4FPkBFVkgk+RM1SRC14wqmhU0aiiUUWjikYVjSqCAhKqV8IVNeEqn5TGQyjhZggBMKQVAQCZTZr57r3B/QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/25fb.png
// module id = 1338
// module chunks = 0